import { navigate, useParams } from '@gatsbyjs/reach-router';

const RedirectPage = () => {
  const { routeparamRedirectPageUrl } = useParams();
  let redirectPageUrl = "";

  if (routeparamRedirectPageUrl !== "" && routeparamRedirectPageUrl !== undefined) {
    redirectPageUrl = decodeURIComponent(routeparamRedirectPageUrl);
  }

  navigate("/" + redirectPageUrl, { replace: true });
  return <></>;
};

export default RedirectPage;
